module.exports = __webpack_public_path__ + "static/social-media-h265-7db5bc77f8dde206be29b6255066ea57.mp4";